<template>
  <vue-final-modal
    :value="store.visible"
    name="prime-complete-popup"
    :classes="['prime-complete-popup__container']"
    :content-class="[
      'prime-complete-popup__shell',
      'v--modal-box',
      'v--modal',
      'prime-complete-popup-modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="store.setVisible"
  >
    <div class="v--modal-close-top">
      <el-button
        @click="store.close"
        icon="el-icon-circle-close"
        style="font-size: 2rem; padding: 0"
        type="text"
      />
    </div>

    <div class="prime-complete-popup">
      <h2 class="pc-h2">
        ヤギプライムへようこそ🎉<br />ご登録ありがとうございます！
      </h2>
      <img
        src="/static/img/08.png"
        alt="ヤギプライムへようこそ🎉ご登録ありがとうございます！"
        class="pc-img"
      />
      <p class="pc-txt">
        ヤギプライムへのお支払いが完了しました。<br />AI文章作成や証明写真風加工、AI面接練習など履歴書作成から転職活動までもっと便利になる機能がたくさん！
      </p>

      <div class="pc-btn">
        <button
          v-if="store.hasResumeData"
          class="pc-step1-btn pc-diagnosis-btn"
          @click="store.goToDiagnosis"
        >
          <span>あなたの隠れスキルを発見</span><br />隠れスキル診断を受ける
        </button>
        <a
          v-else
          href="/format/rirekisho_job_change"
          class="pc-step1-btn pc-diagnosis-btn"
          ><span>履歴書を作ると診断できる！</span><br />まずは履歴書を作る</a
        >
        <button class="pc-back-btn" @click="store.close">
          戻って便利な機能をつかう
        </button>
      </div>
      <a
        href="#"
        class="pc-freelance-link"
        @click.prevent="openTemplateApp('prime_complete')"
        >請求書・見積書などのフリーランス書類をつくる</a
      >
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
/**
 * ヤギプライム決済完了 UI。開閉は Pinia `usePrimeCompletePopupStore`。
 */
import { useTemplateApp } from '@/composables/useTemplateApp'
import { usePrimeCompletePopupStore } from '@/stores/primeCompletePopup'

const store = usePrimeCompletePopupStore()
const { open: openTemplateApp } = useTemplateApp()
</script>

<style lang="scss" scoped>
.prime-complete-popup {
  text-align: center;
  padding: 10px;
  box-sizing: border-box;

  .pc-h2 {
    line-height: 1.4;
    font-size: 18px;
    margin-bottom: 15px;

    @media (width <= 480px) {
      font-size: 16px;
      margin-bottom: 12px;
    }
  }

  .pc-img {
    margin: 10px 0;
    width: 100%;
    max-width: 250px;
    height: auto;

    @media (width <= 480px) {
      max-width: 280px;
      margin: 8px 0;
    }
  }

  .pc-txt {
    text-align: left;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 1.6;
    overflow-wrap: break-word;

    @media (width <= 480px) {
      font-size: 13px;
      margin-bottom: 15px;
    }
  }

  .pc-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    button {
      height: 60px;
    }

    .pc-back-btn {
      width: 100%;
      max-width: 300px;
      padding: 14px 10px;
      font-weight: bold;
      color: #e3165c;
      background: #fff;
      border-radius: 10px;
      border: 1px solid #e3165c;
      cursor: pointer;
      font-size: 14px;
      box-sizing: border-box;

      @media (width <= 480px) {
        max-width: 280px;
        padding: 12px 8px;
        font-size: 13px;
        margin-bottom: 12px;
      }
    }

    .pc-step1-btn {
      width: 100%;
      max-width: 300px;
      padding: 14px 10px;
      margin-bottom: 10px;
      font-weight: bold;
      color: #fff;
      background: #e3165c;
      border-radius: 10px;
      border: 1px solid #e3165c;
      cursor: pointer;
      font-size: 14px;
      text-decoration: none;
      display: block;
      box-sizing: border-box;
      line-height: 1.3;

      span {
        font-size: 12px;

        @media (width <= 480px) {
          font-size: 11px;
        }
      }

      @media (width <= 480px) {
        max-width: 280px;
        padding: 12px 8px;
        font-size: 13px;
      }
    }
  }

  .pc-freelance-link {
    display: inline-block;
    margin-top: 14px;
    font-size: 13px;
    color: #e3165c;
    text-decoration: underline;
  }
}
</style>

<style lang="scss">
// 中央寄せは __container 側。高いときは上からスクロール可能にする
// （align-items:center だと上が切れる）。短いときだけ margin-block:auto で縦中央。
.prime-complete-popup__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 50px 16px 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

// グローバルの .v--modal-box.v--modal が幅を上書きするため、同じ詳細度以上で指定する。
// 幅は課金ダイアログ（YagiprimePaymentDialog）に揃える
.prime-complete-popup__shell.prime-complete-popup-modal.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 0 auto;
  width: calc(100% - 32px);
  max-width: 600px;
  height: auto;
  margin-block: auto;
  border-radius: 8px;
  padding: 20px;

  @media (width <= 480px) {
    padding: 15px;
    width: calc(100vw - 20px);
    max-width: calc(100vw - 20px);
    border-radius: 6px;
  }

  @media (width <= 360px) {
    padding: 10px;
    width: calc(100vw - 10px);
    max-width: calc(100vw - 10px);
  }
}
</style>
